// A proposal's own lifecycle state, as the message carries it. Mirrors BE's ProposalStatus, which a
// DB CHECK constraint pins to exactly these five — BE documents its apply outcomes as a superset.
enum ChatProposalStatus {
  APPLIED = "applied",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
  FAILED = "failed",
  PENDING = "pending",
}

export default ChatProposalStatus;
